import { manualRetryResultSchema } from "@redotech/redo-billing-common/manual-retry-result";
import * as z from "zod";

const retryBillPaymentInput_ = z.object({ billId: z.string() });
export const retryBillPaymentInput: z.ZodType<RetryBillPaymentInput> =
  retryBillPaymentInput_;
export interface RetryBillPaymentInput extends z.infer<
  typeof retryBillPaymentInput_
> {}

// `charge` carries the synchronous Stripe outcome for return-shipping payout
// retries so the UI can report the decline reason. Absent for software bills,
// which settle through the billing engine's own status.
const retryBillPaymentOutput_ = z.object({
  charge: manualRetryResultSchema.optional(),
});
export const retryBillPaymentOutput: z.ZodType<RetryBillPaymentOutput> =
  retryBillPaymentOutput_;
export interface RetryBillPaymentOutput extends z.infer<
  typeof retryBillPaymentOutput_
> {}

export const retryBillPayment = {
  name: "retryBillPayment" as const,
  input: retryBillPaymentInput,
  output: retryBillPaymentOutput,
};
